export default {
    filterOption(state) {
        return state.filterOption;
    },
    dayFilter(state) {
        return state.dayFilter;
    },
    monthFilter(state) {
        return state.monthFilter;
    },
    langFilter(state) {
        return state.langFilter;
    },
    yearFilter(state) {
        return state.yearFilter;
    },
    typeFilter(state) {
        return state.typeFilter;
    },
    keywordFilter(state) {
        return state.keywordFilter;
    },
    channelFilter(state) {
        return state.channelFilter;
    },
    publisherFilter(state) {
        return state.publisherFilter;
    },
    sentimentFilter(state) {
        return state.sentimentFilter;
    },
    irrelativeFilter(state) {
        return state.irrelativeFilter;
    },
    sourceFilter(state) {
        return state.sourceFilter;
    },
    mainCatFilter(state) {
        return state.mainCatFilter;
    },
    subCatFilter(state) {
        return state.subCatFilter;
    },
    detailCatFilter(state) {
        return state.detailCatFilter;
    }
}